import { navegar } from "../../../shared/navegacao/navegacao";
import { FormularioDeLogin } from "./formulario-de-login";
import { LayoutDeAcesso } from "./layout-de-acesso";

export function PaginaDeLogin({ aviso }: { readonly aviso?: string | null }) {
  return (
    <LayoutDeAcesso>
      <FormularioDeLogin aviso={aviso ?? null} aoEntrar={() => navegar("/", { substituir: true })} />
    </LayoutDeAcesso>
  );
}
